import React, { useId } from 'react';

export interface RBWTProps {
  text: string,
  url: string,
  color: string,
}
const RoundedButtonWithTextAround: React.FC<RBWTProps> = ({ color, text, url }) => {
  const id = useId();

  return (
    <a href={url} aria-label={text}>
      <svg
        viewBox="0 0 141 141"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          overflow: 'visible',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          minWidth: '141px',
          minHeight: '141px',
        }}
      >
        <path
          d="M58.398 70.058h23.334M70.065 58.392l11.667 11.666-11.667 11.667"
          style={{
            fill: 'none',
            fillRule: 'nonzero',
            stroke: color,
            strokeWidth: 4,
          }}
        />
        <path
          d="M139.065 70.058c0-38.082-30.918-69-69-69s-69 30.918-69 69 30.918 69 69 69 69-30.918 69-69Z"
          style={{
            fill: 'none',
            stroke: color,
            strokeWidth: 2,
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
          }}
          transform="scale(-1,1) translate(-141, 0)"
          id={id}
        />
        <text fill={color} style={{ fontSize: '1.125rem', lineHeight: '2rem' }} dy={-16}>
          <textPath
            xlinkHref={`#${id}`}
            startOffset="80"
          >
            {text}
          </textPath>
        </text>
      </svg>
    </a>

  );
};

RoundedButtonWithTextAround.propTypes = {};
RoundedButtonWithTextAround.defaultProps = {};

export default RoundedButtonWithTextAround;
